import { onReady } from "../../utils/events/onReady";
import { addEvent } from "../../utils/events/events";
import { onClickOutside } from "../../utils/events/onClickOutside";

export class Dropdown {
    /**
     * Internal placeholder for DOM-objects
     *
     * @type {object}
     * @ignore
     */
    dom = {
        container: undefined
    };

    /**
     *
     * @param {Element} domReference - The element to work from
     */
    constructor(domReference) {
        this.dom.container = domReference;
        onReady(() => this.init());
    }

    CloseSearch() {
        const searchDesktop = document.querySelector(".header__search");

        searchDesktop.addEventListener('animationend', () => {
            if (searchDesktop.classList.contains("animate__fadeOut")) {
                searchDesktop.classList.remove("animate__fadeOut")
                searchDesktop.style = "display:none"
            }
        }, { once: true });
        searchDesktop.style.setProperty('--animate-duration', '0.3s');
        searchDesktop.classList.remove("animate__fadeIn")
        searchDesktop.classList.add("animate__fadeOut")
    }

    OpenDropdown(e) {
        const dropdown = e.currentTarget;

        this.CloseSearch();

        // const list = dropdown.children[1];
        // const ariaValueList = JSON.parse(list.getAttribute("aria-hidden"));
        const ariaValue = JSON.parse(dropdown.children[0].getAttribute("aria-expanded"));
        // list.setAttribute("aria-hidden", !ariaValueList);
        dropdown.children[0].setAttribute("aria-expanded", !ariaValue);
    }


    init() {
        const dropdown = this.dom.container;
        addEvent(dropdown, "click", e => this.OpenDropdown(e));
        onClickOutside(
            dropdown,
            () => {
                dropdown.children[0].setAttribute("aria-expanded", false);
                // dropdown.children[1].setAttribute("aria-hidden", true);
            }
        );
    }
}
